import * as React from 'react';
import * as styled from './styled';
import {Point} from 'api/task/types';
import {InputRange} from './components/InputRange';
import {getTotalScore} from 'components/TaskBuilder/hooks/getTotalScore';
import Input from 'components/Input';
import {PointRangeProps} from './types';

/**
 * The point range component.
 * @param {PointRangeProps} props
 * @return {React.ReactElement<PointRangeProps>}
 * @constructor
 */
export default function PointRange(
    props: PointRangeProps,
): React.ReactElement<PointRangeProps> {
  const totalScore = getTotalScore();
  const range = totalScore / props.length;
  const min = Math.floor(range * props.index + 1);
  const max = Math.floor(range * props.index + range);

  /**
   * The change event handler.
   * @param {Point} point
   */
  function handleChange(point: Point): void {
    const prevPoint = props.points[props.index - 1];

    if (props.points[props.index - 1] !== undefined) {
      if (prevPoint >= point) {
        return props.onChange && props.onChange(prevPoint + 1);
      }
    }

    props.onChange && props.onChange(point);
  }

  /**
   * Render label.
   * @return {JSX.Element}
   */
  function renderLabel(): JSX.Element {
    /**
     * Get the label text.
     * @return {string}
     */
    function getText(): string {
      return props.length > 1 ? (
        String(Number(props.index + 1))
      ) : 'Зачет';
    }

    return (
      <styled.Label>
        {getText()}
      </styled.Label>
    );
  }

  /**
   * Render range.
   * @return {JSX.Element}
   */
  function renderRange(): JSX.Element {
    return (
      <styled.Range>
        <InputRange
          min={0}
          max={totalScore}
          step={1}
          value={props.value}
          onChange={handleChange}
        />
      </styled.Range>
    );
  }

  /**
   * Render input.
   * @return {JSX.Element}
   */
  function renderInput(): JSX.Element {
    return (
      <styled.Input>
        <span>От</span>
        <Input
          type="number"
          min={min}
          max={max}
          value={props.value}
          onChange={(event) => (
            handleChange(Number(event.target.value)
          ))}
        />
        <span>до {max} баллов</span>
      </styled.Input>
    );
  }

  return (
    <styled.Wrapper>
      {renderLabel()}
      {renderRange()}
      {renderInput()}
    </styled.Wrapper>
  );
}
